// extracted by mini-css-extract-plugin
module.exports = {"childrenLayoutWithWebphone":"default_layout_childrenLayoutWithWebphone__cXxBJ","childrenLayoutWithoutWebphone":"default_layout_childrenLayoutWithoutWebphone__8ejaF"};